import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { AuthGuard } from '../../../../libs/lmh/cms/src/lib/guards/auth.guard';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {SecureRouteGuard} from "../../../../libs/lmh/cms/src/lib/guards/secure-route.guard";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'device-list',
    loadChildren: () => import('./devices/devices.module').then(m => m.DevicesModule),
    canActivate: [AuthGuard,SecureRouteGuard]
  },
  {
    path: 'basket',
    loadChildren: () => import('./basket/basket.module').then(m => m.BasketModule),
    canActivate: [AuthGuard,SecureRouteGuard]
  },
  {
    path: 'order-history',
    loadChildren: () => import('./order/order.module').then(m => m.OrderModule),
    canActivate: [AuthGuard,SecureRouteGuard]
  },
  {
    path: 'user-management',
    loadChildren: () => import('./management/management.module').then(m => m.ManagementModule),
    canActivate: [AuthGuard,SecureRouteGuard]
  },
  {
    path: 'error',
    loadChildren: () => import('./error/error.module').then(m => m.ErrorModule),
  },
  {
    path: 'linked-applications',
    loadChildren: () => import('./linked-applications/linked-applications.module').then(m => m.LinkedApplicationsModule),
  },
  {
    path: '**',
    redirectTo: 'error/not-found'
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false })
  ],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule {}
